<template>
    <nav id="sidebar" class="sidebar" :class="{toggled: toggle}">
        <div class="sidebar-content js-simplebar">
            <router-link class="sidebar-brand" :to="{ name: 'dashboard' }">
                <i class="align-middle" data-feather="box"></i>
                <span class="align-middle">CRM</span>
            </router-link>

            <ul class="sidebar-nav">
                <li class="sidebar-item">
                    <router-link :to="{ name: 'dashboard' }" class="sidebar-link">
                        <i class="align-middle" data-feather="sliders"></i> <span class="align-middle">Dashboard</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('requests.list.show')" class="sidebar-item">
                    <router-link :to="{ name: 'requests' }" class="sidebar-link">
                        <i class="align-middle" data-feather="list"></i> <span class="align-middle">Заявки</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('requests.credit_department.show')" class="sidebar-item text-nowrap">
                    <router-link :to="{ name: 'requests.credit_department' }" class="sidebar-link">
                        <i class="align-middle" data-feather="list"></i> <span class="align-middle">Кредитный отдел</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('requests.sales_department.show')" class="sidebar-item">
                    <router-link :to="{ name: 'requests.sales_department' }" class="sidebar-link">
                        <i class="align-middle" data-feather="list"></i> <span class="align-middle">Отдел продаж</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('calls.show')" class="sidebar-item">
                    <router-link :to="{ name: 'calls' }" class="sidebar-link">
                        <i class="fas fa-phone-square-alt" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Звонки</span><BadgeTemp text="new" color="red" to="2022-05-29" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" />
                    </router-link>
                </li>
                <li v-if="$hasPermission('requests.export')" class="sidebar-item">
                    <router-link :to="{ name: 'requests.export' }" class="sidebar-link">
                        <i class="far fa-file-excel" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Экспорт заявок</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('users.list.show')" class="sidebar-item">
                    <router-link :to="{ name: 'users' }" class="sidebar-link">
                        <i class="align-middle" data-feather="users"></i> <span class="align-middle">Пользователи</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('car_warehouse.show')" class="sidebar-item">
                    <router-link :to="{ name: 'car_warehouse' }" class="sidebar-link">
                        <i class="fas fa-warehouse" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Склад</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('deals.show')" class="sidebar-item">
                    <router-link :to="{ name: 'deals' }" class="sidebar-link">
                        <i class="far fa-handshake" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Сделки</span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('affiliate_sales.show')" class="sidebar-item">
                    <router-link :to="{ name: 'affiliate_sales' }" class="sidebar-link">
                        <i class="fas fa-cart-plus" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Доп продукты<BadgeTemp text="new" color="red" to="2022-04-28" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                    </router-link>
                </li>
                <li v-if="$hasPermission('additional_agreements.show')" class="sidebar-item">
                    <router-link :to="{ name: 'additional_agreements' }" class="sidebar-link">
                        <i class="fas fa-clipboard-list" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Доп соглашения<BadgeTemp text="new" color="red" to="2022-04-28" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                    </router-link>
                </li>
                <li v-if="displayConfigs" class="sidebar-item">
                    <a href="#configs" data-toggle="collapse" class="sidebar-link collapsed">
                        <i class="fas fa-cogs" style="width: 18px;height: 18px;font-size: 1rem;"></i> <span class="align-middle">Управление<BadgeTemp text="new" color="red" to="2022-04-16" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: relative; top: -1px; font-size: 70%;" /></span>
                    </a>
                    <ul id="configs" class="sidebar-dropdown list-unstyled collapse " data-parent="#configs">
                        <li v-if="$hasPermission('agencies.manage')" class="sidebar-item">
                            <a @click="openAgenciesManage" class="sidebar-link"><span class="align-middle">Агентства</span></a>
                        </li>
                        <li v-if="$hasPermission('sources.manage')" class="sidebar-item">
                            <router-link :to="{ name: 'config_sources'}" class="sidebar-link"><span class="align-middle">Источники</span></router-link>
                        </li>
                        <li v-if="$hasPermission('document_templates.manage')" class="sidebar-item">
                            <router-link :to="{ name: 'config_document_templates'}" class="sidebar-link"><span class="align-middle">Документы</span><BadgeTemp text="new" color="red" to="2023-02-07" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></router-link>
                        </li>
                        <li v-if="$hasPermission('affiliate_programs.manage')" class="sidebar-item">
                            <router-link :to="{ name: 'config_affiliate_programs'}" class="sidebar-link"><span class="align-middle">Доп продукты</span><BadgeTemp text="new" color="red" to="2022-04-21" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></router-link>
                        </li>
                        <li v-if="$hasPermission('requests.sms.templates.manage')" class="sidebar-item">
                            <router-link :to="{ name: 'config_sms_templates'}" class="sidebar-link"><span class="align-middle">СМС шаблоны</span><BadgeTemp text="new" color="red" to="2022-05-21" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></router-link>
                        </li>
                        <li v-if="$hasPermission('platforms.manage')" class="sidebar-item">
                            <router-link :to="{ name: 'config_platforms'}" class="sidebar-link"><span class="align-middle">Площадки</span><BadgeTemp text="new" color="red" to="2022-08-17" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></router-link>
                        </li>
                        <li v-if="$hasPermission('voice_assistants.manage')" class="sidebar-item">
                            <router-link :to="{ name: 'config_voice_assistants'}" class="sidebar-link"><span class="align-middle">Голосовой ассистент</span></router-link>
                        </li>
                        <li v-if="$hasPermission('dialer.show')" class="sidebar-item">
                            <router-link :to="{ name: 'dialer_campaigns' }" class="sidebar-link"><span class="align-middle">Дайлер</span></router-link>
                        </li>
                        <li v-if="$hasPermission('blacklisted_phones.manage')" class="sidebar-item">
                            <a @click="openBlacklistedPhonesManage" class="sidebar-link"><span class="align-middle">ЧС номеров<BadgeTemp text="new" color="red" to="2025-12-13" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: relative; top: -1px; font-size: 70%;" /></span></a>
                        </li>
                        <li v-if="$hasPermission('telegram_bots.manage')" class="sidebar-item">
                            <a @click="openTelegramBotsManage" class="sidebar-link"><span class="align-middle">Telegram Боты</span></a>
                        </li>
                    </ul>
                </li>
                <li v-if="displayAgencies" class="sidebar-item">
                    <a href="#agencies" data-toggle="collapse" class="sidebar-link collapsed">
                        <i class="fas fa-ad" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Агенство</span>
                    </a>
                    <ul id="agencies" class="sidebar-dropdown list-unstyled collapse " data-parent="#agencies">
                        <li v-if="$hasPermission('agency.show')" class="sidebar-item">
                            <router-link :to="{ name: 'agencies_data' }" class="sidebar-link"><span class="align-middle">Данные</span></router-link>
                        </li>
                        <li v-if="$hasPermission('agency.reports')" class="sidebar-item">
                            <router-link :to="{ name: 'agencies_report' }" class="sidebar-link"><span class="align-middle">Отчет</span></router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="$hasPermission('errors.show')" class="sidebar-item">
                    <router-link :to="{ name: 'errors' }" class="sidebar-link">
                        <i class="fas fa-exclamation-circle" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Ошибки<BadgeTemp text="new" color="red" to="2022-07-29" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                    </router-link>
                </li>
                <li v-if="displayMotivation" class="sidebar-item">
                    <router-link :to="{ name: 'motivation' }" class="sidebar-link">
                        <i class="fas fa-trophy"></i> <span class="align-middle">Мотивация<BadgeTemp text="new" color="red" to="2026-08-03" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                    </router-link>
                </li>
                <template v-if="$hasPermission('operations.list.show')">
                    <li class="sidebar-header">
                        Операции
                    </li>
                    <li class="sidebar-item">
                        <router-link :to="{ name: 'operations', params: {balance_type: 'cars'} }" class="sidebar-link">
                            <i class="fas fa-car" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Машины</span>
                        </router-link>
                    </li>
                    <li class="sidebar-item">
                        <router-link :to="{ name: 'operations', params: {balance_type: 'bank'} }" class="sidebar-link">
                            <i class="fas fa-university" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Банк</span>
                        </router-link>
                    </li>
                    <li class="sidebar-item">
                        <router-link :to="{ name: 'operations', params: {balance_type: 'cash'} }" class="sidebar-link">
                            <i class="fas fa-cash-register" style="width: 18px;height: 18px;font-size: 1.1rem;"></i> <span class="align-middle">Касса</span>
                        </router-link>
                    </li>
                </template>
                <template v-if="$hasPermission('reports.affiliate_sales') || displayReportRequests || $hasPermission('reports.cash') || $hasPermission('reports.operations.categories') || displayReportDepartments || $hasPermission('reports.sales') || $hasPermission('reports.banks')">
                    <li class="sidebar-header">Отчеты</li>
                    <li class="sidebar-item" v-if="$hasPermission('reports.affiliate_sales')">
                        <router-link :to="{ name: 'report_affiliate_sales' }" class="sidebar-link">
                            <span class="align-middle">Доп продукты<BadgeTemp text="new" color="red" to="2022-04-28" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                        </router-link>
                    </li>
                    <li v-if="displayReportRequests" class="sidebar-item">
                        <a href="#report_requests" data-toggle="collapse" class="sidebar-link collapsed">
                            <span class="align-middle">Заявки</span>
                        </a>
                        <ul id="report_requests" class="sidebar-dropdown list-unstyled collapse " data-parent="#report_requests">
                            <li v-if="$hasPermission('reports.requests')" class="sidebar-item">
                                <router-link :to="{ name: 'report_requests' }" class="sidebar-link"><span class="align-middle">Общее</span></router-link>
                            </li>
                            <li v-if="$hasPermission('reports.requests.regions')" class="sidebar-item">
                                <router-link :to="{ name: 'report_requests_regions' }" class="sidebar-link"><span class="align-middle">Регионы</span></router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item" v-if="$hasPermission('reports.cash')">
                        <router-link :to="{ name: 'report_cash' }" class="sidebar-link">
                            <span class="align-middle">Касса<BadgeTemp text="new" color="red" to="2022-11-18" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                        </router-link>
                    </li>
                    <li class="sidebar-item" v-if="$hasPermission('reports.operations.categories')">
                        <router-link :to="{ name: 'reports_operations_categories' }" class="sidebar-link">
                            <span class="align-middle">Операции<BadgeTemp text="new" color="red" to="2023-09-25" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                        </router-link>
                    </li>
                    <li v-if="displayReportDepartments" class="sidebar-item">
                        <a href="#report_departments" data-toggle="collapse" class="sidebar-link collapsed">
                            <span class="align-middle">Отделы</span>
                        </a>
                        <ul id="report_departments" class="sidebar-dropdown list-unstyled collapse " data-parent="#report_departments">
                            <li v-if="$hasPermission('reports.departments.credit')" class="sidebar-item">
                                <router-link :to="{ name: 'report_departments_credit' }" class="sidebar-link"><span class="align-middle">КО</span></router-link>
                            </li>
                            <li v-if="$hasPermission('reports.departments.call_center')" class="sidebar-item">
                                <router-link :to="{ name: 'report_departments_call_center' }" class="sidebar-link"><span class="align-middle">КЦ</span></router-link>
                            </li>
                            <li v-if="$hasPermission('reports.departments.sales')" class="sidebar-item">
                                <router-link :to="{ name: 'report_departments_sales' }" class="sidebar-link"><span class="align-middle">ОП</span></router-link>
                            </li>
                            <li v-if="$hasPermission('reports.call_quality')" class="sidebar-item">
                                <router-link :to="{ name: 'report_call_quality' }" class="sidebar-link"><span class="align-middle">Оценка качества звонков</span></router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item" v-if="$hasPermission('reports.sales')">
                        <router-link :to="{ name: 'report_sales' }" class="sidebar-link">
                            <span class="align-middle">Продажи<BadgeTemp text="new" color="red" to="2022-04-06" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: relative; top: -1px;" /></span>
                        </router-link>
                    </li>
                    <li class="sidebar-item" v-if="$hasPermission('reports.banks')">
                        <router-link :to="{ name: 'report_banks' }" class="sidebar-link">
                            <span class="align-middle">Банки<BadgeTemp text="new" color="red" to="2024-11-30" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: relative; top: -1px;" /></span>
                        </router-link>
                    </li>
                </template>
            </ul>

            <div class="sidebar-bottom d-none">
                <div class="media">
                    <img class="rounded-circle mr-3"
                         src="https://www.gravatar.com/avatar/15ac38b7dfab4e7276deca54d318323c.jpg?s=50&d=mm"
                         alt="Chris Wood" width="40" height="40">
                    <div class="media-body">
                        <h5 class="mb-1">{{ user.name}}</h5>
                        <div>
                            <i class="fas fa-circle text-success"></i> Online
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </nav>
</template>

<script>
    import Form from "vform";
    import {mapGetters} from "vuex";
    import BadgeTemp from "./others/BadgeTemp";

    export default {
        name: "Sidebar",
        components: {BadgeTemp},
        // data: () => ({
        //     toggle: this.$store.getters['sidebar/toggle'],
        // }),
        computed: {
            toggle: function () {
                return this.$store.getters['sidebar/toggle'];
            },
            displayConfigs: function () {
                return this.$hasPermission('sources.manage')
                    || this.$hasPermission('affiliate_programs.manage')
                    || this.$hasPermission('requests.sms.templates.manage')
                    || this.$hasPermission('platforms.manage')
                    || this.$hasPermission('document_templates.manage')
                    || this.$hasPermission('dialer.show');
            },
            displayReportRequests: function () {
                return this.$hasPermission('reports.requests')
                || this.$hasPermission('reports.requests.regions')
            },
            displayReportDepartments: function () {
                return this.$hasPermission('reports.departments.sales')
                || this.$hasPermission('reports.departments.credit')
                || this.$hasPermission('reports.departments.call_center')
                || this.$hasPermission('reports.call_quality')
            },
            displayAgencies: function () {
                return this.$hasPermission('agency.show');
            },
            displayMotivation: function () {
                if (!this.$hasPermission('reports.motivation.show')
                    && !this.$hasPermission('reports.motivation.rop')) {
                    return false;
                }
                return (this.user.allowed_platforms || []).some(platform => platform.motivation && platform.status === 1);
            },
            ...mapGetters({
                user: 'auth/user'
            })
        },
        methods: {
            requestOpenDrawer(id) {
                this.$bus.$emit('request:open-drawer', id);
            },
            openAgenciesManage() {
                this.$bus.$emit('agencies:open-manage');
            },
            openBlacklistedPhonesManage() {
                this.$bus.$emit('blacklisted_phones:open-manage');
            },
            openTelegramBotsManage() {
                this.$bus.$emit('telegram_bots:open-manage');
            }
        }
    }
</script>

<style scoped>

</style>
